var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransporte(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#475569"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11C16 11 12 11.5 12 15V24.5C12 26.43 13.57 28 15.5 28L14 29.5V30H16.23L18.23 28H22L24 30H26V29.5L24.5 28C26.43 28 28 26.43 28 24.5V15C28 11.5 24.42 11 20 11ZM15.5 26C14.67 26 14 25.33 14 24.5C14 23.67 14.67 23 15.5 23C16.33 23 17 23.67 17 24.5C17 25.33 16.33 26 15.5 26ZM19 19H14V15H19V19ZM21 19V15H26V19H21ZM24.5 26C23.67 26 23 25.33 23 24.5C23 23.67 23.67 23 24.5 23C25.33 23 26 23.67 26 24.5C26 25.33 25.33 26 24.5 26Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporte);
export default __webpack_public_path__ + "static/media/transporte.459eabf0e11e9c00e07000e8ad186fa2.svg";
export { ForwardRef as ReactComponent };